export default "__VITE_ASSET__cc5465d2__"